<template>
  <div class="alsok-panel-container" v-bind:style="{ marginBottom: marginBottom + 'px' }">
    <slot></slot>
  </div>
</template>

<script>
/**
 * @module FE-CU38_サブユーザー権限変更画面_コンポーネント
 */
export default {
  name: 'AlsokPanel',
  props: {
    marginBottom: {
      type: Number,
      default: 30,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/index';

.alsok-panel-container {
  padding: 10px;
  border-radius: 5px;
  background-color: $alsok-blue;
}
</style>
